<template>
  <div class="game-page">
    <header class="game-page-header">
      <button
        type="button"
        class="game-page-back"
        @click="goBack"
        :aria-label="$store.state.language === 'en' ? 'Go back' : 'နောက်သို့'"
      >
        <i
          class="fas fa-chevron-left"
          aria-hidden="true"
        ></i>
      </button>
      <div class="game-page-heading">
        <h1 class="game-page-title">{{ displayProviderName }}</h1>
        <p
          v-if="!isBuffaloProvider"
          class="game-page-meta"
        >
          {{ displayGames.length }}
          {{ $store.state.language === 'en' ? 'games' : 'ဂိမ်း' }}
        </p>
      </div>
      <div class="game-page-search-field">
        <i
          class="fas fa-search game-page-search-icon"
          aria-hidden="true"
        ></i>
        <input
          v-model="name"
          type="search"
          enterkeyhint="search"
          autocomplete="off"
          class="game-page-search"
          :placeholder="$t('home.search_game')"
        />
      </div>
    </header>

    <section class="game-page-body">
      <div
        v-if="showEmpty"
        class="game-page-empty"
      >
        <i
          class="fas fa-gamepad"
          aria-hidden="true"
        ></i>
        <template v-if="$store.state.language === 'en'">
          No games match your search. Try another name.
        </template>
        <template v-else>
          ရှာဖွေမှုနှင့် ကိုက်ညီသော ဂိမ်းမရှိပါ။ အခြားစာသားဖြင့် စမ်းကြည့်ပါ။
        </template>
      </div>

      <div
        v-else
        class="game-page-grid"
      >
        <!-- <template v-if="isBuffaloProvider">
          <button
            v-for="index in 2"
            :key="'bn-' + index"
            type="button"
            class="game-page-card"
            @click="fetchBuffaloData('new')"
          >
            <div class="game-page-card__thumb">
              <img
                src="https://storage.googleapis.com/spacetech2/general/Buffalolong-Card.webp"
                alt="African Buffalo New"
                loading="lazy"
              />
            </div>
            <span class="game-page-card__name">African Buffalo New</span>
          </button>
          <button
            v-for="index in 2"
            :key="'bo-' + index"
            type="button"
            class="game-page-card"
            @click="fetchBuffaloData()"
          >
            <div class="game-page-card__thumb">
              <img
                src="https://storage.googleapis.com/spacetech2/general/Buffalolong-Old-Card.webp"
                alt="African Buffalo Old"
                loading="lazy"
              />
            </div>
            <span class="game-page-card__name">African Buffalo Old</span>
          </button>
        </template> -->

        <button
          v-for="(game, index) in displayGames"
          :key="game.gameID + '-' + index"
          type="button"
          class="game-page-card"
          @click="gameInit(game)"
        >
          <div class="game-page-card__thumb">
            <img
              :src="imageLinkGenerate(game.gameID, game.provider, game)"
              :alt="game.gameName"
              loading="lazy"
            />
          </div>
          <span class="game-page-card__name">{{ game.gameName }}</span>
        </button>
      </div>
    </section>

    <div class="col-4">
      <div
        id="limit"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        @click="hideLimit()"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br /><br />
              </span>
              <span>{{ limitText }}</span>
              <br /><br />
              <span class="text-dark text-sm">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="gameInit(desiredGame)"
                >
                  {{
                    $store.state.language === 'en' ? 'Play The Game' : 'ဂိမ်းဆော့မည်။'
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { mapActions } from 'vuex';
import { openGameInIframe } from '@/libs/openGameInIframe';
import { thumbnailUrlGameId } from '@/libs/thumbnailGameId';

export default {
  data() {
    return {
      games: [],
      rows: 0,
      provider: 'Pragmatic',
      name: null,
      newGames: [],
      limitText: '',
      desiredGame: null,
      isMobile: false,
    };
  },
  computed: {
    isBuffaloProvider() {
      return this.$route.query.provider === 'Buffalo';
    },
    displayProviderName() {
      return this.providerGenerator(this.$route.query.provider || this.provider);
    },
    displayGames() {
      // if (this.isBuffaloProvider) return [];
      return this.newGames.length > 0 ? this.newGames : this.games;
    },
    showEmpty() {
      // if (this.isBuffaloProvider) return false;
      return this.displayGames.length === 0;
    },
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    },
    providerGenerator(provider) {
      if (provider === 'FatPanda') {
        return 'Fat Panda';
      }
      if (provider === 'Pragmatic') {
        return 'Pragmatic Play';
      }
      return provider || 'Games';
    },
    ...mapActions(['fetchUser']),
    hideLimit() {
      $('#limit').modal('hide');
    },
    showAlertBox(game) {
      if (this.$route.query.provider === 'PGSoft') {
        this.limitText = 'PG Soft တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။';
      } else if (this.$route.query.provider === 'FaChai') {
        this.limitText = 'FaChai Provider တွင် 1 unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      }
      $('#limit').modal('show');
      this.desiredGame = game;
    },
    async fetchBuffaloData(type = null) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        let res = null;

        if (type === 'new') {
          res = await axios.get('/new-buffalo-data', {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
        } else {
          res = await axios.get('/buffalo-data', {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
        }

        if (res.data.gameURL) {
          openGameInIframe(this.$router, this.$store, res.data.gameURL);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        console.log(error);
      }
    },

    imageLinkGenerate(gameId, type, game = null) {
      // const id = thumbnailUrlGameId(gameId, type, game);
      const id = gameId;
      if (type === 'Jili') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${id}.webp`;
        // return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${id}.webp`;
      }
      if (type === 'PGSoft') {
        // return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${id}.webp`;
        return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${id}.webp`;
      }
      if (type === 'Live22') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${id}.webp`;
      }
      if (type === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${id}.jpg`;
      }
      if (type === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${id}.jpg`;
      }
      if (type === 'Playstar') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${id}.webp`;
      }
      if (type === 'FaChai') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${id}.webp`;
      }
      if (type === 'JOKER' || type === 'Joker') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${id}.webp`;
      }
      if (type === '5G') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${id}.webp`;
      }
      if (type === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${id}.webp`;
      }
      if (type === 'AceWin') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${id}_EN.webp`;
      }
      if (type === 'JDB') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${id}.webp`;
      }
      if (type === 'Buffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${id}.webp`;
      }
      if (type === 'HotDog') {
        return `https://res.hotdog-gaming.com/banners/380x500/${id}.png`;
      }
      if (type === 'Rich') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${id}.webp`;
      }
      if (type === 'Rich88') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${id}.webp`;
      }
      if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${id}.webp`;
      }
      if (type === 'BTG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${id}.webp`;
      }
      if (type === '2J') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${id}.webp`;
      }
      if (type === 'VA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${id}_en.webp`;
      }
      if (type === 'BNG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${id}.webp`;
      }
      if (type === 'AfricanBuffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${id}.webp`;
      }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${id}.webp`;
      // return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${id}.webp`;
    },

    detectMob() {
      let check = false;
      /* eslint-disable */
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        ) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);
      /* eslint-enable */
      return check;
    },

    async fetchGames() {
      try {
        const res = await axios.get('/games', {
          params: {
            provider: this.$route.query.provider,
            type: 'vs',
          },
        });
        this.games = res.data.data;

        this.games = this.games.filter((game) => game.gameTypeID.includes('vs'));

        if (this.$route.query.provider === 'Pragmatic') {
          const games = this.games;
          const lastTenGames = games.slice(-10);
          const remainingGames = games.slice(0, -10);
          this.games = lastTenGames.concat(remainingGames);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async gameInit(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const providerID = game.provider;
        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: providerID,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        console.log('Game Init Response:', res.data);
        const data = res?.data?.data ?? res?.data ?? {};
        const apiDescription =
          data?.description ??
          res?.data?.description ??
          data?.message ??
          res?.data?.message ??
          '';
        let gameUrl =
          data.gameUrl ??
          data.game_url ??
          data.url ??
          res?.data?.gameUrl ??
          res?.data?.url ??
          '';
        gameUrl = String(gameUrl || '').trim();

        // PGSoft (and some providers) return HTML instead of a URL: render via blob URL
        let rawHtml =
          data.html ??
          res?.data?.html ??
          (typeof res?.data === 'string' && res.data.trimStart().startsWith('<')
            ? res.data
            : null) ??
          (gameUrl && gameUrl.trimStart().startsWith('<') ? gameUrl : null);
        if (!rawHtml) rawHtml = '';
        if (rawHtml && typeof rawHtml === 'string') {
          const blob = new Blob([rawHtml], { type: 'text/html;charset=utf-8' });
          gameUrl = URL.createObjectURL(blob);
        } else if (gameUrl && !gameUrl.startsWith('blob:')) {
          gameUrl += gameUrl.includes('?') ? '&' : '?';
        }

        if (gameUrl) {
          openGameInIframe(this.$router, this.$store, gameUrl);
        } else {
          Dialog.alert({
            message: apiDescription,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
          });
        }

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
        Dialog.alert({
          message:
            error.response?.data?.description ||
            (this.$store.state.language === 'en'
              ? 'Something went wrong.'
              : 'အမှားတစ်ခုဖြစ်ပါသည်။'),
          confirmButtonText:
            this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
    },
    isPWA() {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        document.referrer.startsWith('android-app://')
      );
    },
  },
  watch: {
    provider() {
      this.fetchGames();
    },
    name() {
      const q = (this.name || '').toLowerCase().trim();
      if (!q) {
        this.newGames = [];
        return;
      }
      this.newGames = this.games.filter((game) => game.gameName.toLowerCase().includes(q));
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    await this.fetchGames();

    this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
/* Layout lives in global .game-page* (style.scss); scoped empty kept for future */
</style>
